import API from './base';

const version = 'v1';
const booking = '/booking';

export default {
  newBooking(payload) {
    return API.post(`${version}${booking}`, payload);
  },

  getBookings() {
    return API.get(`${version}${booking}`);
  },

  getBooking(payload) {
    return API.get(`${version}${booking}/${payload}`);
  },

  getLockerBookingCodes(bookingId) {
    return API.get(`${version}${booking}/${bookingId}/lockers/bookings`);
  },

  updateBooking(payload) {
    return API.put(`${version}${booking}`, payload);
  },

  cancelBooking(payload) {
    return API.put(`${version}${booking}/cancel`, payload);
  },
};
